module.exports = __webpack_public_path__ + "images/videoCaseStudy-checkout-top.svg?h=a94179483d88bfe9198e73bafdb827bc";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-checkout-top.svg
// module id = 2848
// module chunks = 12